import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-black to-red-950/20 border-t border-red-900">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center">
          {/* Coluna Esquerda - Redes Sociais */}
          <div className="flex flex-col md:flex-row gap-6 justify-center md:justify-start">
            <a
              href="https://www.instagram.com/tech.tidee/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors text-base cursor-pointer whitespace-nowrap"
            >
              Instagram
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61586689553638"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors text-base cursor-pointer whitespace-nowrap"
            >
              Facebook
            </a>
          </div>

          {/* Coluna Centro - Copyright */}
          <div className="text-center">
            <p className="text-gray-600 text-sm">© 2025 Tech Tide. Todos os direitos reservados.</p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-red-600 transition-colors text-xs mt-2 inline-block cursor-pointer"
            >
              Website Builder
            </a>
          </div>

          {/* Coluna Direita - Links */}
          <div className="flex flex-col md:flex-row gap-6 justify-center md:justify-end">
            <Link
              to="/sobre"
              className="text-gray-400 hover:text-red-600 transition-colors text-base cursor-pointer whitespace-nowrap text-center md:text-left"
            >
              Sobre
            </Link>
            <Link
              to="/cursos"
              className="text-gray-400 hover:text-red-600 transition-colors text-base cursor-pointer whitespace-nowrap text-center md:text-left"
            >
              Cursos
            </Link>
            <Link
              to="/suporte"
              className="text-gray-400 hover:text-red-600 transition-colors text-base cursor-pointer whitespace-nowrap text-center md:text-left"
            >
              Suporte
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
